import React from "react";
import { useSelector } from "react-redux";
import { Route, useRouteMatch } from "react-router";
import { StateShape } from "checkout/ts/redux/store";
import { StepName } from "checkout/ts/utils/StepName";
import { PaymentType, TransactionTokenPaidyData, TransactionTokenType } from "univapay-node";

import { SwitchContent } from "../../router/SwitchContent";
import FormAddress from "../common/FormAddress";
import FormCustomerInfo from "../common/FormCustomerInfo";
import { FormPending } from "../common/FormPending";
import { showCustomerIdScreen } from "../common/FormTokenSelector";

import FormConfirm from "./FormConfirm";
import FormTokenReview from "./FormTokenReview";
import FormTokenSelector from "./FormTokenSelector";
import FormPaymentPreview from "./PaidyPaymentPreview";
import FormProcessing from "./PaidyProcessing";

export type PaidyCheckoutData = {
    data: TransactionTokenPaidyData;
};

const stateSelector = (state: StateShape) => ({
    showTokenSelectScreen: showCustomerIdScreen(state.tokens.tokens, PaymentType.PAIDY),
    hidePrivacyLink: state.application.params.params.hidePrivacyLink,
    submitButtonText: state.application.params.params.submitButtonText,
    isAcceptVisible:
        !state.application.params.params.hideRecurringCheckbox &&
        state.application.params.params.tokenType === TransactionTokenType.RECURRING,
});

const CustomerInfoForm = () => {
    const { hidePrivacyLink, submitButtonText, isAcceptVisible } = useSelector(stateSelector);

    return (
        <FormCustomerInfo
            nextButtonLabel={submitButtonText}
            showPrivacyLink={!hidePrivacyLink}
            showAcceptField={isAcceptVisible}
        />
    );
};

export const Content = () => {
    const { path } = useRouteMatch();
    const { showTokenSelectScreen } = useSelector(stateSelector);

    return (
        <SwitchContent>
            <Route path={path} exact component={showTokenSelectScreen ? FormTokenSelector : CustomerInfoForm} />

            <Route path={`${path}/${StepName.INFO}`} component={CustomerInfoForm} />

            <Route path={`${path}/${StepName.ADDRESS}`} component={FormAddress} />

            <Route path={`${path}/${StepName.PROCESSING}`} exact component={FormProcessing} />

            <Route path={`${path}/${StepName.PREVIEW}`} component={FormPaymentPreview} />

            <Route path={`${path}/${StepName.CONFIRM}`} component={FormConfirm} />

            <Route path={`${path}/${StepName.PENDING}`} component={FormPending} />

            <Route path={`${path}/${StepName.TOKEN_REVIEW}`} component={FormTokenReview} />

            <Route path={`${path}/${StepName.TOKEN_SELECT}`} component={FormTokenSelector} />
        </SwitchContent>
    );
};

export default Content;
